export default "__VITE_ASSET__itIEgMCj__"